export interface IProvider {
  Provider: string;
  Url: string;
  DocLink: string;
  Description: string;
  Order: number | string;
  IsActive?: boolean;
}

export interface ISeedModelInfo {
  Model: string;
  ModelGoodName: string;
  MaxTokens: number;
  DefaultTemp: number;
  ContextLength: number;
  InputCostPerMillion: number;
  OutputCostPerMillion: number;
  IsActive: boolean;
  DefaultBaseUrl?: string;
}

export enum ServicePlatform {
  OFFICIAL_API = 'official_api',
  OPEN_DEPLOYMENT = 'open_deployment',
  CUSTOM_DEPLOYMENT = 'custom_deployment',
}

export type ProviderFilterType = 'official' | 'open';

export interface IModelListPayload {
  provider?: string | null;
  search: string | null;
  page: number;
  page_size: number;
}

export interface IModelInfo {
  _id: string;
  ProjectKey: string;
  Provider?: string;
  ModelType?: string;
  ServicePlatform?: string;
  Description?: string;
  DisplayName: string;
  ModelName?: string;
  ApiKey: string;
  BaseUrl: string;
  Status: string;
  IsActive: boolean;
  OpenAiOrganizationId?: string;
  OpenAiProjectId?: string;
  ApiVersion?: string | null;
  DeploymentName?: string | null;
  CustomParameters?: Record<string, string>;
  CustomHeaders?: Record<string, string>;
}

export interface IModelListResponse {
  models: IModelInfo[];
  project_key: string;
  total: number;
  page: number;
  page_size: number;
  has_next: boolean;
}

export interface IValidateModelResponse {
  valid?: {
    valid: boolean;
    message: string;
    model_id: string;
    provider: string;
    model_name: string;
  };
  message?: string;
}

export interface ICreateModelPayload {
  provider: string;
  service_platform: string;
  version?: string;
  model_name: string;
  display_name?: string;
  api_key: string;
  base_url: string;
  openai_organization_id?: string;
  openai_project_id?: string;
  api_version?: string;
  deployment_name?: string;
  project_key: string;
  DefaultTemp?: number;
  MaxTokens?: number;
  custom_parameters?: Record<string, unknown>;
  custom_headers?: Record<string, string>;
}

export interface ICreateModelResponse {
  is_success: boolean;
  detail?: string;
  message?: string;
  error?: string;
}
